import { useEffect, useRef } from 'react';
import { LoadingScreen } from '../../../components/loading-screen';
import type { DashboardPageProps } from '../../../lib/dashboard-page';

export function SwitchAccountPage({ handlers }: DashboardPageProps) {
  const { navigationHandler, authHandler } = handlers;
  const hasRun = useRef<boolean>(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    async function switchSite() {
      const teamId = navigationHandler.params().teamId ?? '';
      const isNewTeam = 'new-team' in navigationHandler.query();

      await authHandler.changeSite(teamId);

      navigationHandler.navigate(isNewTeam ? '/integrations/platform' : '/', {
        excludeSiteId: true,
        excludeSiteEnv: true,
      });
    }

    switchSite();
  }, [navigationHandler, authHandler]);

  return <LoadingScreen />;
}
